import styled from "styled-components";
import { GRAY_LIGHTEST } from "@streeteasy/design-system/colors";

import { smallScreen } from "src/shared/constants/screenSizes";

export const MobileAppsContainer = styled.section`
  background-color: ${GRAY_LIGHTEST};
  padding: 40px 48px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 40px 24px;
  }
`;

export const MobileAppIcons = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 40px 0;
`;

export const Img = styled.img`
  margin: 8px;
  max-width: 152px;
  width: 100%;
`;

export const Link = styled.a`
  font-size: 0;
`;
